export default __webpack_public_path__ + "static/media/basic_1.c8f98076.svg";